<ng-container *ngIf="data$ | async as data">
  <div [ngClass]="isSuccess ? 'd-none' : 'forgot-password-container'">
    <div class="forgot-password-wrapper">
      <div class="forgot-password-heading">
        <a [routerLink]="['/login']" rel="noopenner noreferrer" *ngIf="!asmEnabled; else backLinkForAsm">
          <ng-container *ngTemplateOutlet="innerBackLinkTemplate"></ng-container>
        </a>
        <ng-template #backLinkForAsm>
          <a [routerLink]="['/login']" [queryParams]="{ asm: true }" rel="noopenner noreferrer">
            <ng-container *ngTemplateOutlet="innerBackLinkTemplate"></ng-container>
          </a>
        </ng-template>
        <ng-template #innerBackLinkTemplate>
          <i class="material-icons back-icon">keyboard_arrow_left</i>
          {{ 'forgotPassword.goBack' | cxTranslate }}
        </ng-template>
        <h1>{{ 'forgotPassword.heading' | cxTranslate }}</h1>
        <p>{{ 'forgotPassword.message' | cxTranslate }}</p>
      </div>
      <div class="forgot-password-form">
        <div
          class="forgot-error alert alert-danger alert-dismissible collapse show"
          role="alert"
          *ngIf="err && !!errorMsg"
        >
          {{ errorMsg }}
          <button type="button" class="close" (click)="clearErrorMessage()" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form [formGroup]="forgotPasswordForm" (ngSubmit)="forgotPassword()">
          <mat-form-field appearance="outline" class="w-100 mt-3" [hideRequiredMarker]="true">
            <mat-label>{{ 'forgotPassword.email' | cxTranslate }}</mat-label>
            <input
              matInput
              placeholder="{{ 'forgotPassword.email' | cxTranslate }}"
              formControlName="email"
              id="emailInput"
              (change)="emailChange($event, forgotPasswordForm.invalid)"
            />
            <mat-error *ngIf="forgotPasswordForm.invalid && (forgotPasswordForm.dirty || forgotPasswordForm.touched)">
              {{ 'forgotPassword.errorMessage' | cxTranslate }}
            </mat-error>
          </mat-form-field>
          <div class="forgot-password-button">
            <button mat-button class="btn btn-primary" [class.disabled]="isDisabled" [disabled]="isDisabled">
              {{ 'forgotPassword.resetButton' | cxTranslate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div [ngClass]="isSuccess ? 'forgot-password-success' : 'd-none'">
    <h1>{{ 'forgotPassword.success' | cxTranslate }}</h1>
    <p>{{ 'forgotPassword.successMessage' | cxTranslate : { email: forgotPasswordForm.controls.email.value } }}</p>
    <div class="forgot-password-success-button">
      <button mat-button class="btn-primary" [routerLink]="['/login']">
        {{ 'forgotPassword.successButton' | cxTranslate }}
      </button>
    </div>
  </div>
</ng-container>
